// Sahifa almashganda <head> dagi SEO teglarini yangilaydi: title, description,
// canonical, Open Graph, Twitter va <html lang>. index.html dagi standart teglar
// qayta ishlatiladi (dublikat yaratilmaydi).

export const SITE_URL = String(process.env.REACT_APP_SITE_URL || 'https://new.ukiu.uz').replace(/\/$/, '');
export const SITE_NAME = 'KIUF';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;
const MAX_DESCRIPTION_LENGTH = 160;

const OG_LOCALES = { uz: 'uz_UZ', ru: 'ru_RU', en: 'en_US', ko: 'ko_KR' };

export const DEFAULT_SEO = {
  uz: {
    title: 'KIUF — Farg‘onadagi Koreya xalqaro universiteti',
    description:
      'Korea International University in Fergana (KIUF) — Farg‘onadagi Koreya xalqaro universiteti rasmiy sayti: fakultetlar, yo‘nalishlar, qabul, yangiliklar va xalqaro hamkorlik.'
  },
  ru: {
    title: 'KIUF — Корейский международный университет в Фергане',
    description:
      'Официальный сайт Korea International University in Fergana (KIUF): факультеты, направления, приём, новости и международное сотрудничество.'
  },
  en: {
    title: 'KIUF — Korea International University in Fergana',
    description:
      'Official website of Korea International University in Fergana (KIUF): faculties, programs, admission, news and international cooperation.'
  },
  ko: {
    title: 'KIUF — 우즈베키스탄 한국국제대학교 (페르가나)',
    description: '우즈베키스탄 페르가나 한국국제대학교(KIUF) 공식 웹사이트: 학부, 전공, 입학, 뉴스 및 국제 협력.'
  }
};

function cleanText(value = '') {
  return String(value || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function truncateDescription(value = '', maxLength = MAX_DESCRIPTION_LENGTH) {
  const text = cleanText(value);

  if (text.length <= maxLength) {
    return text;
  }

  const cut = text.slice(0, maxLength - 1);
  const lastSpace = cut.lastIndexOf(' ');
  return `${(lastSpace > maxLength * 0.6 ? cut.slice(0, lastSpace) : cut).replace(/[\s,.;:–-]+$/, '')}…`;
}

export function buildPageTitle(title = '', languageCode = 'uz') {
  const pageTitle = cleanText(title);
  const fallback = (DEFAULT_SEO[languageCode] || DEFAULT_SEO.uz).title;

  if (!pageTitle) {
    return fallback;
  }

  return pageTitle.includes(SITE_NAME) ? pageTitle : `${pageTitle} | ${SITE_NAME}`;
}

// Ijtimoiy tarmoqlar faqat to'liq http(s) manzilli rasmni ko'rsatadi (base64 emas).
export function resolveShareImage(image = '') {
  const value = String(image || '').trim();

  if (/^https?:\/\//i.test(value)) {
    return value;
  }

  if (value.startsWith('/') && !value.startsWith('//')) {
    return `${SITE_URL}${value}`;
  }

  return DEFAULT_IMAGE;
}

function upsertMeta(attribute, key, content) {
  if (typeof document === 'undefined') return;

  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute('content', content);
}

function upsertCanonical(href) {
  let element = document.head.querySelector('link[rel="canonical"]');

  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'canonical');
    document.head.appendChild(element);
  }

  element.setAttribute('href', href);
}

export function applySeo({ title, description, image, pathname = '/', languageCode = 'uz', type = 'website' } = {}) {
  if (typeof document === 'undefined') return;

  const defaults = DEFAULT_SEO[languageCode] || DEFAULT_SEO.uz;
  const fullTitle = buildPageTitle(title, languageCode);
  const metaDescription = truncateDescription(description) || defaults.description;
  const url = `${SITE_URL}${pathname === '/' ? '/' : pathname.replace(/\/+$/, '')}`;
  const shareImage = resolveShareImage(image);

  document.title = fullTitle;
  document.documentElement.setAttribute('lang', languageCode);

  upsertMeta('name', 'description', metaDescription);
  upsertCanonical(url);

  upsertMeta('property', 'og:title', fullTitle);
  upsertMeta('property', 'og:description', metaDescription);
  upsertMeta('property', 'og:url', url);
  upsertMeta('property', 'og:type', type);
  upsertMeta('property', 'og:image', shareImage);
  upsertMeta('property', 'og:locale', OG_LOCALES[languageCode] || OG_LOCALES.uz);

  upsertMeta('name', 'twitter:title', fullTitle);
  upsertMeta('name', 'twitter:description', metaDescription);
  upsertMeta('name', 'twitter:image', shareImage);
}
